<template>    
        <a :href="hit.url" class="hiq-event-puff__link hiq-events-listing__hit-item hiq-event-puff env-m-bottom--medium" :title="'Läs mer om ' +hit.title + ' - ' +hit.dateText">
            
                <div role="img" :aria-label="hit.imageAltText" class="hiq-event-puff__image" :style="[hit.imageUrl ? { backgroundImage : 'url(' + encodeURI(hit.imageUrl) + ')' } : {}]"></div>
                <div class="hiq-event-puff__date">
                    <div>{{hit.dateText}}</div>
                </div>
                <div class="env-p-around--xx-small env-h--100 env-d--flex env-flex--column">
                    <small class="hiq-event-puff__location env-text--uppercase env-m-top--small">{{hit.location}}</small>
                    <div>
                        <span class="hiq-event-puff__title">{{hit.title}}</span>
                    </div>
                </div>            
        </a>
    
</template>

<script >
import Vue from 'vue';

export default Vue.extend({
    name: "SearchHit",
    props: {
        hit: Object,
        index: Number
    },
    computed: {
        translation() { return this.$store.getters.translation },
        itemCategoriesText() { 
            return this.hit.categories.join (' | ');
        },
    }
});
</script>

